<template>
    <timeline :active-index="2" :time-line-items="steps">
        <template v-slot:form>
            <div class="card card-custom h-100">
                <div class="card-header">
                    <div class="card-title">{{ __('general.stores_sum') }}</div>
                </div>
                <div class="card-body">
                    <SelectWithIcons :label="__('general.store_count')" :value.sync="form.store_count"></SelectWithIcons>
                    <span class="invalid-feedback d-inline" v-if="form.errors.store_count">
                            {{ form.errors.store_count }}
                        </span>
                </div>
            </div>

            <div class="d-flex justify-content-end mt-20">
                <button @click="previousStep" class="mr-auto py-4 btn btn-secondary">
                    <i class="fas fa-arrow-circle-left mr-3"></i>Zurück
                </button>
                <button @click="submit()" class="btn btn-primary">
                    Weiter<i class="fas fa-arrow-circle-right ml-3"></i>
                </button>
            </div>

        </template>
    </timeline>

</template>

<script>
import AccountSetupLayout from '@layouts/AccountSetupLayout';
import Timeline from '@components/Timeline';
import SelectWithIcons from '@components/AccountSetup/SelectWithIcons';

export default {
    name: 'StoreCount',
    components: {SelectWithIcons, Timeline},
    layout: AccountSetupLayout,
    props: {
        steps: Object,
        storeCount: Number,
    },
    data() {
        return {
            form: this.$inertia.form({
                store_count: null,
            }),
        };
    },
    methods: {
        previousStep() {
            this.$inertia.get(this.$route('account-setup-contact.show'));
        },
        submit() {
            this.form.post(this.$route('account-setup-store-count.update'), {
                preserveState: true,
                preserveScroll: true,
                onError: () => {
                    toastr.error(__('general.error_check_data'));
                },
                onSuccess:() => {
                    toastr.success('Filialanzahl wurde erfolgreich gespeichert.')
                }
            });
        },
    },
    beforeMount() {
        if (this.storeCount) {
            this.form.store_count = this.storeCount;
        }
    },
};
</script>
